var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProphecy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128,
    fill: "#FFE100"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 123,
    stroke: "#776900",
    strokeWidth: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3926_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.419 97.5C74.3117 97.5 46.7531 107.912 27 126.752C47.6719 147.08 69.2625 156.5 101.419 156.5C130.373 156.5 152.409 147.08 174 126.752C155.625 106.424 133.116 97.5 101.419 97.5Z",
    stroke: "#480087",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.419 97.5C74.3117 97.5 46.7531 107.912 27 126.752C47.6719 147.08 69.2625 156.5 101.419 156.5C130.373 156.5 152.409 147.08 174 126.752C155.625 106.424 133.116 97.5 101.419 97.5Z",
    stroke: "#480087",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 94.5C119.225 94.5 134 109.275 134 127.5C134 145.725 119.225 160.5 101 160.5C82.7746 160.5 68 145.725 68 127.5C68 109.275 82.7746 94.5 101 94.5ZM101 112.5C92.7157 112.5 86 119.216 86 127.5C86 135.784 92.7157 142.5 101 142.5C109.284 142.5 116 135.784 116 127.5C116 119.216 109.284 112.5 101 112.5Z",
    fill: "#480087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 101.5C126 98.5 139.5 85 148 69C152.5 104.5 170 110.5 210.5 96.5C172 140.5 176.5 144 191 177C157 153 151.5 148 105 177C117.5 145.5 142 123.5 107.5 101.5Z",
    stroke: "#480087",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 101.5C126 98.5 139.5 85 148 69C152.5 104.5 170 110.5 210.5 96.5C172 140.5 176.5 144 191 177C157 153 151.5 148 105 177C117.5 145.5 142 123.5 107.5 101.5Z",
    stroke: "#480087",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 91,
    r: 12.5,
    fill: "#480087"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 115,
    rx: 21,
    ry: 15.5,
    fill: "#480087"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169,
    cy: 146,
    rx: 18,
    ry: 17.5,
    fill: "#480087"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3926_65",
    x: 15.001,
    y: 42.4779,
    width: 221.857,
    height: 158.159,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_3926_65"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProphecy);
export default __webpack_public_path__ + "static/media/prophecy.c40aaa7452810c282deeea5bcf68a1e9.svg";
export { ForwardRef as ReactComponent };